import { memo, useState, useEffect, useCallback, useMemo, useRef } from "react";
import { Row, Col, Container, Button, Dropdown } from 'react-bootstrap';
import { BzButton, BzDotsLoader, BzDropdown, BzInputText, BzToolTip } from "../../../components";
import { WATCHLIST_GRID_INDEX, TL_INDEX, SUPPORT_RESISTANCE_VIEW, ORDER_TYPES, ORDER_PRODUCT_TYPES, SCRIP_INSTRUMENTS, ORDER_ENTRY_TYPES, ORDER_ENTRY_CONSTANTS, IS_MULTILEG_ALLOWED, MSG_MASTER, LAYOUT_TYPE, SURV_MEASURE_POPUP_ACTION, DISPLAY_EXCHANGE_NAME, ORDER_VALIDITY, EXCHANGE_NAME_API, GLOBAL_FUNCTION_TYPES } from "../../../utils/global_variables";
import { convertScripResponseWatchlistGrid, convertToDate, dateFormatter, deepClone, getMappedMktSegIdFromApiExchangeName, getProductTypeValue, handleBlink, handleKeyDownOnDiv, roundToNearest, validateLTPPriceBand, getApiExchangeNameFromMktSegId, calculateSupportRestistanceValues, getGSMGradeDescriptionFromScrip, convertNumberWithCommasForCurrency } from "../../../utils/global_functions";
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
import { useWFHMessages } from '../../../hooks';
import SupportResistance from '../../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../../AllExchangesMarketDepth';
import { sendTouchlineRequest } from '../../../apis/web_socket';
import { getWfhTouchlineLastTick } from '../../../redux/actions/wfh';
import { InlineScripSeach } from "../../Search";
import { setCautionaryMessageFromPopup, getLTPPriceBand, getMultiLegData, getScripOrderInfo, getSpreadOrder, updateSpreadOrderConfirmed, updateSpreadOrderInfo, handleSpreadSideOrder, getSpreadOrderSuccess, getOrderMarginInfo, updateSpreadInfoForBrokerage } from "../../../redux/actions/orders";
import { toastConfig } from "../../../redux/actions/toast";
import ZeroStates from "../../ZeroStates";
import moment from "moment";
import { getFutureTabData } from "../../../redux/actions/marketOverview";
import { LoginLoader } from "../../Login";
import { getScripbyTokenAndMktSegId } from "../../../apis";

const objDropdownOptions = {
    heading: ["BUY/SELL", "EXPIRY", "SYMBOL", "ORDER TYPE", "LOTS", "PRICE", "VALIDITY"],
    arrType: ["DAY", "IOC"]
};


const objSelectOrderOptionInit = {
    frequency: "MONTHLY",
    every: "First",
    day_date: "Day",
    day: "Monday",
    everyForWeekly: "MONDAY",
    productType: "MARGIN",
    productTypeDesc: '',
    validityTypes: ORDER_VALIDITY.DAY,
    orderType: ORDER_ENTRY_TYPES.RL,
    orderBy: 'Quantity',
    isAmo: false,
    selectSpecificFrequencyDate: 0
};

const Spread = ({ setActiveTabKey, layoutType, activeButtonToggleIndex,
    activeTabKey, orderEntryTab }) => {

    const dispatch = useDispatch();
    const [spreadOrderData, setSpreadOrderData] = useState([]);
    const [supportResistance, setSupportResistance] = useState({});
    const [arrScripInformation, setArrScripInformation] = useState([]);
    const [objTwoltps, setTwoSpreadORdersLtp] = useState({});
    const [objSpreadBidAndAskPrice, setBidAndASkprice] = useState({});
    const [buySellBtnSwapClick, setSellBuyBtnSwapClick] = useState(false);
    const [buyAndSellScrip, setBuyAndSellScrip] = useState([]);
    const [bToggleSearchBar, setBToggleSearchBar] = useState(false);
    const [selectOrderOption] = useState(objSelectOrderOptionInit);
    const [toggleBracketOrder] = useState({ isShow: false, strProductType: ORDER_PRODUCT_TYPES.COVER });
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    const [orderInputs] = useState({ scripQuantity: 1, scripLot: 1, scripAmount: 0, scripPrice: '', slTrigger: 0, quantity: 0, capPrice: 0, numberOfInstallment: 0, intradayTrigger: 0, intradayLimit: 0, intradayTrailing: 0, intradayProfit: 0, discQty: 0 });
    const isOrderConfirmed = useSelector(state => state.orders.isSpreadOrderConfirmed);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End
    const multiSpreadOrderInfo = useSelector(state => state?.orders?.multiSpreadOrderInfo);
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    const [spreadOrderInfo, setSpreadOrderInfo] = useState({ intradayLimit: 0, quantity: 1, amount: '0.00', validity: ORDER_VALIDITY.DAY, exchange: "", orderType: ORDER_ENTRY_TYPES.RL_MKT });
    const objScripOrderInfo = useSelector(state => state.orders.scripOrderInfo);
    const ltpPriceBandMaster = useSelector(state => state.orders.ltpPriceBandMaster);
    const buy_or_sell = useSelector(state => state?.orders?.buy_or_sell);
    const [isLoader, setIsLoader] = useState(false);
    const [disablePlaceOrder, setDisablePlaceOrder] = useState(false);

    const { orderInfo } = useMemo(() => ({ orderInfo: objScripOrderInfo?.scripData, activeMktSegId: objScripOrderInfo?.activeExchangeId }), [objScripOrderInfo]);

    const modalData = useSelector(state => state?.modals?.modalData);
    const spreadOrderArr = useSelector(state => state.orders.spreadOrderInfo);
    const spreadSideOrderStatus = useSelector(state => state.orders.spreadSideOrderStatus);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const inlineSearchRef = useRef();
    const marketDepthRef = useRef(null);

    const expiryDateStart = useMemo(() => {
        return spreadOrderArr?.length ? dateFormatter(convertToDate(spreadOrderArr[0]?.nExpiryDate)) : "";
    }, [spreadOrderArr]);
    const expiryDateEnd = useMemo(() => {
        return spreadOrderArr?.length ? dateFormatter(convertToDate(spreadOrderArr[1]?.nExpiryDate)) : "";
    }, [spreadOrderArr]);



    const handleBrokerageForSpread = useCallback(() => {
        //24-07-2025 --Ameersha N-- as bRokerae model doest have access to data directly for spread spread values which are need to form brokerage will be added in redux and brokerage componenet will act accordingly --Start
        dispatch(updateSpreadInfoForBrokerage({ buyAndSellScrip, spreadOrderInfo, objLegsLtps: objTwoltps }));
        dispatch(handleModal([{ 'BROKERAGE_CHARGES_MODAL': true }]));
        //24-07-2025 --Ameersha N-- as bRokerae model doest have access to data directly for spread spread values which are need to form brokerage will be added in redux and brokerage componenet will act accordingly --End
    }, [dispatch, buyAndSellScrip, spreadOrderInfo, objTwoltps]);

    useWFHMessages('global_function', (e) => {
        //24-07-2025 --Ameersha N-- as side tray Show brokerage and charges click doesnt have direct functionality to trigger aa global dispathevent have been used will be triggered by this case and redux will be updated --Start
        if (e?.detail?.length > 0) {
            e?.detail?.forEach((eachType) => {
                switch (eachType) {
                    case GLOBAL_FUNCTION_TYPES.OPENING_BROKERAGE_FROM_SIDE_SPREAD:
                        handleBrokerageForSpread();
                        break;
                    default:
                        break;
                }
            });
        }
        //24-07-2025 --Ameersha N-- as side tray Show brokerage and charges click doesnt have direct functionality to trigger aa global dispathevent have been used will be triggered by this case and redux will be updated --End
    });

    const [isShowMarketDepth, setIsShowMarketDepth] = useState(false);
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('MarketDepth');

    const handleMarketDepthClick = () => {
        setIsShowMarketDepth(curr => {
            if (!curr) {
                setTimeout(() => {
                    marketDepthRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 100);
            }
            return !curr;
        });
    };

    const arrFutureTabData = useSelector(state => state.marketOverview?.arrFutureTabData);
    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - Start

    //PrachiTawde : 05-05-2023 : BT-106776 -  Breeze - Display Brokerage and statutory charges - End

    //Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - Start
    const onValueClick = useCallback((value) => {
        if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {
            setSpreadOrderInfo(prevState => ({ ...prevState, amount: value?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) }));
        }
    }, [spreadOrderInfo, orderInfo]);
    //Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry - End

    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    useEffect(() => {
        // setting buy and sell scrip on load
        if (layoutType === LAYOUT_TYPE.HORIZONTAL) {
            if (spreadOrderArr?.length > 0) {
                if (spreadOrderArr[0]?.nTransactionType) {
                    setSellBuyBtnSwapClick(spreadOrderArr[0]?.nTransactionType === 'BUY' ? false : true);
                    setBuyAndSellScrip([
                        { ...spreadOrderArr[0], buySellType: spreadOrderArr[0]?.nTransactionType },
                        { ...spreadOrderArr[1], buySellType: spreadOrderArr[1]?.nTransactionType },
                    ]);
                    return;
                }
                setSellBuyBtnSwapClick(buy_or_sell === 'BUY' ? true : false);
                setBuyAndSellScrip([
                    { ...spreadOrderArr[0], buySellType: buy_or_sell === 'BUY' ? 'SELL' : 'BUY' },
                    { ...spreadOrderArr[1], buySellType: buy_or_sell === 'BUY' ? 'BUY' : 'SELL' },
                ]);
            }
            else { }
        } else if (layoutType === LAYOUT_TYPE.VERTICAL) {
            if (!spreadSideOrderStatus && spreadOrderArr?.length > 0) {
                if (spreadOrderArr[0]?.nTransactionType) {
                    setSellBuyBtnSwapClick(spreadOrderArr[0]?.nTransactionType === 'BUY' ? false : true);
                    setBuyAndSellScrip([
                        { ...spreadOrderArr[0], buySellType: spreadOrderArr[0]?.nTransactionType },
                        { ...spreadOrderArr[1], buySellType: spreadOrderArr[1]?.nTransactionType },
                    ]);
                } else if (multiSpreadOrderInfo?.placeOrder) {
                    let data = multiSpreadOrderInfo?.spreadOrderPayload?.leg_details;
                    setSellBuyBtnSwapClick(data[0]?.transaction_type === 'BUY' ? false : true);
                    setBuyAndSellScrip([
                        { ...spreadOrderArr[0], buySellType: data[0]?.transaction_type },
                        { ...spreadOrderArr[1], buySellType: data[1]?.transaction_type },
                    ]);
                } else {
                    setSellBuyBtnSwapClick(buy_or_sell === 'BUY' ? true : false);
                    setBuyAndSellScrip([
                        { ...spreadOrderArr[0], buySellType: buy_or_sell === 'BUY' ? 'SELL' : 'BUY' },
                        { ...spreadOrderArr[1], buySellType: buy_or_sell === 'BUY' ? 'BUY' : 'SELL' },
                    ]);
                }
            }
            else { }
        }
    }, [buy_or_sell, spreadOrderArr, spreadSideOrderStatus, layoutType]);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    useEffect(() => {
        // sending touchline request for the scripMargininfo(2scrips) of scrip selected
        if (spreadOrderArr?.length > 0) {
            const arr = spreadOrderArr?.map((eachMarginScripinfo) => {
                return {
                    exchangeId: orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                    token: eachMarginScripinfo?.nToken
                };
            });
            sendTouchlineRequest(arr);
            if (spreadOrderArr?.length > 0 && orderInfo?.length > 0) {
                let newObject = {};
                newObject[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[0]?.nToken}`] = '';
                newObject[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[1]?.nToken}`] = '';
                setTwoSpreadORdersLtp(newObject);
            } else { }

        } else { }
    }, [spreadOrderArr, orderInfo, setTwoSpreadORdersLtp]);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End


    useEffect(() => {
        sendTouchlineRequest([
            { exchangeId: orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: orderInfo?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true },
        ]);
        if (!spreadOrderData?.length)
            setSpreadOrderData(orderInfo);
    }, [orderInfo, spreadOrderData]);



    const handleArrGridRowData = useCallback((eDetail, segmentId, token) => {
        const detail = eDetail;
        const arrScripDetails = orderInfo;
        if (segmentId === detail[TL_INDEX.SEGMENT_ID] && token === detail[TL_INDEX.TOKEN]) {
            //By HiralK : 06-09-2023 : For Price optimization - Start
            arrScripDetails[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = (detail[TL_INDEX.LAST_TRADE_PRICE]);//.toFixed(arrScripDetails[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
            arrScripDetails[WATCHLIST_GRID_INDEX.LTP_PERCENT] = detail[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            // const nAbsPrevColse = (detail[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);
            // if (nAbsPrevColse > 0) {
            //     detail[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = '+' + nAbsPrevColse.toString();
            //     (orderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != "EQ" && orderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]?.includes("-"));
            // } else if (nAbsPrevColse < 0) {
            //     detail[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
            // }
            // else {
            //     detail[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = nAbsPrevColse.toString();
            // }
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            arrScripDetails[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] = detail[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
            arrScripDetails[WATCHLIST_GRID_INDEX.BID_PRICE] = detail[TL_INDEX.BUY_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.BID_PRICE_INDICATOR] = detail[TL_INDEX.BUY_PRICE_INDICATOR];
            arrScripDetails[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] = detail[TL_INDEX.NET_CHANGE_INDICATOR];
            arrScripDetails[WATCHLIST_GRID_INDEX.BID_QUANTITY] = detail[TL_INDEX.BUY_QTY];
            arrScripDetails[WATCHLIST_GRID_INDEX.ASK_PRICE] = detail[TL_INDEX.SELL_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.ASK_PRICE_INDICATOR] = detail[TL_INDEX.SELL_PRICE_INDICATOR];
            arrScripDetails[WATCHLIST_GRID_INDEX.ASK_QTY] = detail[TL_INDEX.SELL_QTY];
            arrScripDetails[WATCHLIST_GRID_INDEX.HIGH] = detail[TL_INDEX.HIGH_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.LOW] = detail[TL_INDEX.LOW_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.OPEN] = detail[TL_INDEX.OPEN_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.CLOSE] = detail[TL_INDEX.CLOSE_PRICE];
            arrScripDetails[WATCHLIST_GRID_INDEX.VOLUME] = detail[TL_INDEX.VOLUME];
            arrScripDetails[WATCHLIST_GRID_INDEX.ATP] = detail[TL_INDEX.AVG_TRADED_PRICE];
            setArrScripInformation([...arrScripDetails]);
            //By HiralK : 06-09-2023 : For Price optimization - End


        }
    }, [orderInfo]);

    useEffect(() => {
        if (orderInfo && orderInfo[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) { //ManasaB : 11-10-2024 : Blank page issue from Order cart to spread
            if (!spreadOrderInfo.exchange) {
                const exchangeID = getApiExchangeNameFromMktSegId(orderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID]);
                setSpreadOrderInfo(prevState => ({ ...prevState, exchange: exchangeID, exchangeNo: orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID], quantity: spreadOrderArr[0]?.nQuantity || spreadOrderInfo?.quantity || 1 }));
            }
        }
    }, [orderInfo, spreadOrderArr, spreadOrderInfo]);


    const handleDataChange = useCallback((detail) => {
        // setting ltp for first spread scrip in spreadOrderArr
        const updatedDetail = deepClone(detail);
        if (spreadOrderData?.length > 0 && spreadOrderArr?.length > 0) {
            let segmentIDOne = spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[0]?.nToken;
            let segmentIDTwp = spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[1]?.nToken;

            if (segmentIDOne === updatedDetail[TL_INDEX?.SEGMENT_ID] + '_' + updatedDetail[TL_INDEX?.TOKEN]) {
                setTwoSpreadORdersLtp(prevState => {

                    let abc = { ...prevState, [`${spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[0]?.nToken}`]: Number(updatedDetail[TL_INDEX?.LAST_TRADE_PRICE])?.toFixed(spreadOrderData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) };
                    return abc;
                });
            } else { }

            // setting ltp for second spread scrip in spreadOrderArr
            if (segmentIDTwp === updatedDetail[TL_INDEX?.SEGMENT_ID] + '_' + updatedDetail[TL_INDEX?.TOKEN]) {
                setTwoSpreadORdersLtp(prevState => {
                    let abc = {
                        ...prevState, [`${spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[1]?.nToken}`]: { ltp: Number(updatedDetail[TL_INDEX?.LAST_TRADE_PRICE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), changeInLtp: Number(updatedDetail[TL_INDEX?.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), ltpPercent: Number(updatedDetail[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }
                    };
                    return abc;
                });
            } else { }
        } else {

        }

    }, [spreadOrderArr, spreadOrderData]);

    useWFHMessages('touchline', (e) => {

        if (spreadOrderData && spreadOrderData[WATCHLIST_GRID_INDEX.TOKEN] === e.detail[TL_INDEX.TOKEN] && spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID] === e.detail[TL_INDEX.SEGMENT_ID]) {
            handleArrGridRowData([...e.detail], orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], orderInfo?.[WATCHLIST_GRID_INDEX.TOKEN]);
        } else { }
        handleDataChange(e?.detail);

    });


    useEffect(() => {
        if (orderInfo?.length > 0 && spreadOrderArr?.length > 0) {
            const lastTickData = dispatch(getWfhTouchlineLastTick());
            const matchedScrip = lastTickData[orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
            const matchedScripOne = lastTickData[orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + spreadOrderArr[0]?.nToken];
            const matchedScripTwo = lastTickData[orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + spreadOrderArr[1]?.nToken];
            if (matchedScrip?.length > 0) {
                handleArrGridRowData(matchedScrip, orderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], orderInfo?.[WATCHLIST_GRID_INDEX.TOKEN]);
                const bid = matchedScrip[TL_INDEX.BUY_PRICE];
                const ask = matchedScrip[TL_INDEX.SELL_PRICE];
                let newObject = {};

                newObject[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]}`] = {
                    bidPrice: bid,
                    askPrice: ask
                };
                setBidAndASkprice(
                    newObject
                );
            } else { }
            // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders Start
            if (matchedScripOne?.length > 0) {
                if (orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === matchedScripOne[TL_INDEX?.SEGMENT_ID] && spreadOrderArr[0]?.nToken === matchedScripOne[TL_INDEX?.TOKEN]) {
                    setTwoSpreadORdersLtp(prevState => { return { ...prevState, [`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[0]?.nToken}`]: { ltp: Number(matchedScripOne[TL_INDEX?.LAST_TRADE_PRICE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), changeInLtp: Number(matchedScripOne[TL_INDEX?.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), ltpPercent: Number(matchedScripOne[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) } }; });
                } else { }
            } else { }
            if (matchedScripTwo?.length > 0) {
                if (orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] === matchedScripTwo[TL_INDEX?.SEGMENT_ID] && spreadOrderArr[1]?.nToken === matchedScripTwo[TL_INDEX?.TOKEN]) {
                    setTwoSpreadORdersLtp(prevState => { return { ...prevState, [`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID] + '_' + spreadOrderArr[1]?.nToken}`]: { ltp: Number(matchedScripTwo[TL_INDEX?.LAST_TRADE_PRICE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), changeInLtp: Number(matchedScripTwo[TL_INDEX?.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]), ltpPercent: Number(matchedScripTwo[TL_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) } }; });
                } else { }
            } else { }
            // Parshva S : 20/03/2024 : BT 107070 Breeze Spread Orders End
        } else { }
    }, [orderInfo, dispatch, handleArrGridRowData, spreadOrderArr, buySellBtnSwapClick]);

    //Ameersha N : 30-01-2024 : BT-107070 - Breeze - Spread Order entry - Start
    useEffect(() => {
        if (orderInfo?.length > 0 && spreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL_MKT) {
            // on swap button toggling the ask and bid price of the scrip for the legindicator
            if (buySellBtnSwapClick) {
                setSpreadOrderInfo(prevState => { return { ...prevState, amount: isNaN(parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.askPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])) ? 0.00.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) : parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.askPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) }; });
            } else {
                setSpreadOrderInfo(prevState => { return { ...prevState, amount: isNaN(parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.bidPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])) ? 0.00.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) : parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.bidPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) }; });
            }
        } else { }
    }, [buySellBtnSwapClick, orderInfo, objSpreadBidAndAskPrice]);
    //Ameersha N : 30-01-2024 : BT-107070 - Breeze - Spread Order entry - End


    useEffect(() => {
        if (arrScripInformation?.length !== 0) {
            const resitancePivotObj = calculateSupportRestistanceValues(arrScripInformation, 'Classic', '(H+L+C)/3');
            setSupportResistance(resitancePivotObj);
        } else { }
    }, [arrScripInformation]);

    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (isNaN(value) && value?.toString() !== '-') {
            setSpreadOrderInfo(prevState => ({ ...prevState, [name]: '' }));
        } else {
            setSpreadOrderInfo(prevState => ({ ...prevState, [name]: value.slice(0, ORDER_ENTRY_CONSTANTS.PRICE_LENGTH) }));
        }
    };

    const onHandleClick = useCallback((name) => {
        handleBlink(name);
        switch (name) {
            case "quantitySub":
                if (!!spreadOrderInfo.quantity && spreadOrderInfo.quantity > 1) {
                    setSpreadOrderInfo({ ...spreadOrderInfo, quantity: parseInt(+spreadOrderInfo.quantity) - 1 });
                } else {
                    setSpreadOrderInfo({ ...spreadOrderInfo, quantity: 1 });
                }
                break;
            case "quantityAdd":
                if (!!spreadOrderInfo.quantity) {
                    setSpreadOrderInfo({ ...spreadOrderInfo, quantity: parseInt(+spreadOrderInfo.quantity) + 1 });
                } else {
                    setSpreadOrderInfo({ ...spreadOrderInfo, quantity: 1 });
                }
                break;

            case "amountSub":
                const nRoundedPrice = roundToNearest(parseFloat(spreadOrderInfo?.amount), orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], 'up');
                let nMaxValue = Math.min(isNaN(nRoundedPrice) ? 0 : nRoundedPrice - orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], ORDER_ENTRY_CONSTANTS.PRICE_MAX_RANGE);
                let PriceinPaise = parseInt(Math.round(parseFloat((nMaxValue * orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                let selPriceTick = orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] * orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                if (PriceinPaise % parseInt(selPriceTick) !== 0) {
                    nMaxValue = (parseFloat(nMaxValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR])).toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                }
                setSpreadOrderInfo({ ...spreadOrderInfo, amount: parseFloat(nMaxValue).toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) });
                break;
            case "amountAdd":
                if (!!spreadOrderInfo.amount) {
                    const nRoundedPrice = roundToNearest(parseFloat(spreadOrderInfo?.amount), orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], 'up');
                    let nMaxValue = Math.min(isNaN(nRoundedPrice) ? 0 : nRoundedPrice + orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK], ORDER_ENTRY_CONSTANTS.PRICE_MAX_RANGE);
                    let PriceinPaise = parseInt(Math.round(parseFloat((nMaxValue * orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toString())).toString());
                    let selPriceTick = orderInfo[WATCHLIST_GRID_INDEX.PRICE_TICK] * orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR];
                    if (PriceinPaise % parseInt(selPriceTick) !== 0) {
                        nMaxValue = (parseFloat(nMaxValue) - (PriceinPaise % parseInt(selPriceTick)) / parseInt(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR])).toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
                    }
                    setSpreadOrderInfo({ ...spreadOrderInfo, amount: parseFloat(nMaxValue).toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) });
                }
                break;
            default:
                break;
        }

    }, [orderInfo, spreadOrderInfo]);
    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End


    useEffect(() => {
        dispatch(getLTPPriceBand());
    }, [dispatch]);





    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const spreadOrderPayload = useMemo(() => {
        /*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - Start*/
        if (spreadOrderData?.length > 0 && buyAndSellScrip.length > 0) {
            let leg_details = [];
            leg_details = buyAndSellScrip.map((scrip, i) => {
                return {
                    leg_no: i + 1,
                    price: objTwoltps[`${spreadOrderData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + scrip?.nToken}`] !== "" ? objTwoltps[`${spreadOrderData[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + scrip?.nToken}`]?.ltp || "0.00" : "0.00", // sell scrip last trade price
                    quantity: (spreadOrderData?.[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT] === EXCHANGE_NAME_API.NCDEX_DERV_API) || spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === 'FUTSTK' || spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === "FUTIDX" ? scrip?.nRegularLot * spreadOrderInfo?.quantity : spreadOrderInfo?.quantity || 1,
                    // quantity: spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === 'FUTSTK' || spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === "FUTIDX" ? scrip?.nRegularLot * spreadOrderInfo?.quantity : spreadOrderInfo?.quantity || 1, // dont remove. might need for future
                    transaction_type: scrip?.buySellType,
                    others: {
                        decimal_loc: spreadOrderData[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR],
                        market_lot: spreadOrderData[WATCHLIST_GRID_INDEX?.REGULAR_LOT],
                        price_tick: scrip?.nPriceTick
                    },
                    scrip_info: {
                        exchange: spreadOrderData[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT] === 'NSECDS' ? "NSE_CUR" : spreadOrderData[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT] === 'BSECDS' ? "BSE_CUR" : spreadOrderData[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT],
                        expiry_date: dateFormatter(convertToDate(scrip?.nExpiryDate)),
                        instrument_name: spreadOrderData[WATCHLIST_GRID_INDEX?.INSTRUMENT],
                        option_type: spreadOrderData[WATCHLIST_GRID_INDEX?.OPTIONTYPE],
                        scrip_token: scrip?.nToken,
                        series: scrip?.sSeries?.replace(/\s+/g, ''),
                        strike_price: spreadOrderData[WATCHLIST_GRID_INDEX?.STRIKEPRICE],
                        symbol: scrip?.sSymbol?.replace(/\s+/g, '')
                    }
                };
            });
            /*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - end*/
            let order_time = modalData?.data?.orderTime || modalData?.data?.scripOrderInfo?.orderTime;
            const payload = {
                leg_details: leg_details,
                order_time: order_time || 0,
                priceDiff: spreadOrderInfo?.amount?.toString() === '0.00' ? orderInfo[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] : spreadOrderInfo?.amount?.toString(),
                prot_perc: "",
                type: "SPREAD",
                validity: spreadOrderInfo?.validity
            };
            return payload;
        } else {
            return {};
        }
    }, [buyAndSellScrip, modalData, objTwoltps, orderInfo, spreadOrderData, spreadOrderInfo]);


    const spreadConfirmationModalData = useMemo(() => {
        if (spreadOrderData && spreadOrderPayload?.leg_details?.length > 0) {
            return {
                heading: `${spreadOrderData[WATCHLIST_GRID_INDEX?.SYMBOL]}: ${expiryDateStart?.slice(0, 2)}${expiryDateStart?.slice(2, 5)} - ${expiryDateEnd?.slice(0, 2)}${expiryDateEnd?.slice(2, 5)} ${spreadOrderArr[0]?.sInstrumentName?.slice(0, 3)}`,
                quantity: spreadOrderInfo?.quantity === null ? 1 : Number(spreadOrderInfo?.quantity),
                regularLot: spreadOrderArr[0]?.nRegularLot,
                price: spreadOrderInfo?.amount,
                validity: spreadOrderInfo?.validity,
                approximateAmount: Number(Number(spreadOrderInfo?.quantity) * Number(spreadOrderArr[0]?.nRegularLot)) * parseFloat(spreadOrderInfo?.amount),
                spreadOrderPayload: spreadOrderPayload, // this is the final payload for spread order api payload,
                gatewayOrderNo: modalData?.data?.scripOrderInfo?.gatewayOrderNo || modalData?.data?.gatewayOrderNo,
                decimalLocatorLength: orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                orderTime: modalData?.data?.scripOrderInfo?.orderTime || modalData?.data?.orderTime,
                instrument: orderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE],
                orderType: spreadOrderInfo?.orderType,
                placeOrder: orderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 1,
                isBuySell: buyAndSellScrip[0]?.buySellType === 'BUY' ? 0 : 1,
            };
        } else {
            return { placeOrder: false };
        }
    }, [expiryDateEnd, expiryDateStart, modalData, orderInfo, spreadOrderArr, spreadOrderData, spreadOrderInfo, spreadOrderPayload, buyAndSellScrip]);  //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    const getValidateLTPPriceBand = useCallback(() => {
        let nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        if (selectOrderOption?.orderType?.includes(ORDER_ENTRY_TYPES.SL) && !isNaN(parseFloat(orderInputs?.slTrigger)) && parseFloat(orderInputs?.slTrigger) > 0) {
            nTriggerPrice = parseFloat(orderInputs?.slTrigger);
        } else {
            nTriggerPrice = parseFloat(orderInputs?.intradayTrigger);
        }
        const objLtpValid = validateLTPPriceBand(arrScripInformation, arrScripInformation[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE], activeButtonToggleIndex, parseFloat(spreadOrderInfo?.amount), selectOrderOption?.orderType, ltpPriceBandMaster, nTriggerPrice);
        if (!objLtpValid?.valid) {
            if (objLtpValid?.isRestrictive) {
                dispatch(toastConfig({ show: true, message: objLtpValid?.errorMsg, button: [{ btnName: "Ok", className: "btn btn-solid ms-3", type: 'CLOSE' }] }));
                dispatch(updateSpreadOrderConfirmed(false));
                return false;
            } else {
                dispatch(toastConfig({
                    show: true, message: objLtpValid?.errorMsg, button: [{
                        btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: () => {
                            dispatch(updateSpreadOrderConfirmed(true));
                            dispatch(toastConfig({ show: false }));
                        }
                    }, { btnName: "No", className: "btn btn-outline-active ms-3", type: 'CLOSE' }]
                }));
                return true;
            }
        } else {
            dispatch(updateSpreadOrderConfirmed(true));
            return true;
        }
    }, [activeButtonToggleIndex, arrScripInformation, dispatch, ltpPriceBandMaster, orderInputs, selectOrderOption, spreadOrderInfo]);
    const survelienceConfirmationHandler = useCallback((nUserResp, scripInfo) => {
        dispatch(setCautionaryMessageFromPopup(nUserResp, scripInfo[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION], scripInfo[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], scripInfo[WATCHLIST_GRID_INDEX.TOKEN]));
        dispatch(toastConfig({ show: false }));
        if (nUserResp === 1) {
            getValidateLTPPriceBand();
        } else {
            // dispatch(updateSingleScripOrderConfirmed(false));
            dispatch(toastConfig({ show: false }));
        }
    }, [dispatch, getValidateLTPPriceBand]);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const handlePlaceOrderButton = useCallback((e) => {
        e?.preventDefault();
        // Show Survilience alert
        let decLoc = '1'.padEnd(orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH] + 1, 0);
        let price = spreadOrderInfo?.amount * decLoc;
        let priceTick = orderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] * decLoc;
        if (parseInt(Math.round(price) % parseInt(priceTick)) !== 0) {
            dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: MSG_MASTER.NNSL62 + orderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK] }));
            return;
        }
        if (arrScripInformation[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] && arrScripInformation[WATCHLIST_GRID_INDEX.SURV_MEASURE_DESCRIPTION] !== "0") {
            const strMsg = getGSMGradeDescriptionFromScrip(arrScripInformation);
            if (strMsg) {
                dispatch(toastConfig({ show: true, message: strMsg, button: [{ btnName: "Yes", className: "btn btn-solid ms-3", onClickHandler: (e) => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.YES, arrScripInformation) }, { btnName: "No", className: "btn btn-outline-active ms-3", onClickHandler: () => survelienceConfirmationHandler(SURV_MEASURE_POPUP_ACTION.NO, arrScripInformation) }] }));
                return false;
            } else { }
        } else {
            return getValidateLTPPriceBand();
        }
    }, [arrScripInformation, dispatch, getValidateLTPPriceBand, orderInfo, spreadOrderInfo, survelienceConfirmationHandler]);

    const handleConfirmModal = useCallback(() => {
        dispatch(updateSpreadOrderConfirmed(false));
        dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }], true));
        dispatch(getScripOrderInfo({ ...objScripOrderInfo, scripOrderData: spreadConfirmationModalData }));
        dispatch(handleModalData({
            data: {
                scripOrderInfo: spreadConfirmationModalData, spreadOrder: spreadOrderData,
                spreadOrderPayload: spreadOrderInfo, orderEntryTab: orderEntryTab, activeTabKey: activeTabKey, isModifyOrder: modalData?.data?.isModifyOrder
            }
        }));
    }, [activeTabKey, dispatch, modalData, objScripOrderInfo, orderEntryTab, spreadConfirmationModalData, spreadOrderData, spreadOrderInfo]);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End


    useEffect(() => {
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            if (spreadSideOrderStatus) {
                dispatch(updateSpreadOrderInfo({ ...multiSpreadOrderInfo }));
                setIsLoader(true);
                setTimeout(() => {
                    setIsLoader(false);
                }, 500);
            } else {
                dispatch(updateSpreadOrderInfo(spreadConfirmationModalData));
            }
        } else { }
    }, [spreadConfirmationModalData, spreadSideOrderStatus, multiSpreadOrderInfo, dispatch]);

    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - Start
    useEffect(() => {
        if (isOrderConfirmed && layoutType === LAYOUT_TYPE.HORIZONTAL) {
            handleConfirmModal();
        } else if (isOrderConfirmed && layoutType === LAYOUT_TYPE.VERTICAL) {
            dispatch(updateSpreadOrderConfirmed(false));
            dispatch(getScripOrderInfo({ ...objScripOrderInfo, scripData: spreadConfirmationModalData }));
            dispatch(updateSpreadOrderInfo(spreadConfirmationModalData));
        }
    }, [dispatch, handleConfirmModal, isOrderConfirmed, layoutType, objScripOrderInfo, spreadConfirmationModalData]);
    // Parshva Shah :03/11/2023 : BT-114196 - Breeze - LTP based Price band Implementation - End



    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const onSwapClick = useCallback(() => {
        if (spreadConfirmationModalData?.gatewayOrderNo) {
            return;
        } else {
            handleBlink('buySellToggeleIcon');
            setSellBuyBtnSwapClick(prevState => !prevState);
            /*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - Start*/
            setBuyAndSellScrip(prevState => {
                return [
                    { ...prevState[0], buySellType: prevState[0]?.buySellType === 'BUY' ? 'SELL' : 'BUY' },
                    { ...prevState[1], buySellType: prevState[1]?.buySellType === 'SELL' ? 'BUY' : 'SELL' }
                ];
            });
        }
        /*Parshva S: 26-10-2023 : BT-120114 - Breeze - Order Book - Spread - end*/
    }, [spreadConfirmationModalData]);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    useEffect(() => {
        if (spreadOrderData?.length && !arrFutureTabData)
            dispatch(getFutureTabData({ segment_id: spreadOrderData?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], symbol: spreadOrderData?.[WATCHLIST_GRID_INDEX.SYMBOL].split('-')[0], instrument: spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK : spreadOrderData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] }));
    }, [arrFutureTabData, dispatch, spreadOrderData]);

    //Parshva S : 20-03-2024 : BT-107070 - Breeze - Spread Order entry - Start
    const handleConvertSpreadToMultiLeg = useCallback(() => {
        // Ajitesh 01/10/2024 Calls api call to get scrip info 116 length array for each leg in spread order and returns a promise due to async/await
        const scripinfoPromises = spreadOrderArr.map(async (eachSpreadOrder) => {
            const objResp = await getScripbyTokenAndMktSegId([{ mkt: getApiExchangeNameFromMktSegId(spreadOrderData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: eachSpreadOrder.nToken }]);
            const formattedScripinfo = convertScripResponseWatchlistGrid(objResp?.data?.result);
            const scripinfoForEachLeg = formattedScripinfo[0];
            return scripinfoForEachLeg;
        });

        // Ajitesh 01/10/2024 Once all promises are resolved we get an array of 2 arrays, each of which holds correct scrip info
        const result = Promise.all(scripinfoPromises).then((scripinfoForEachLeg) => {
            // Ajitesh 01/10/2024 we then loop over original spread order legs and add correct scrip information array to the extraInfo property
            const correctScripInfoForEachLeg = spreadOrderArr.map((eachSpreadOrder, i) => {
                return {
                    activeButtonToggleIndex: buyAndSellScrip[i]?.buySellType === 'BUY' ? 0 : 1,
                    ask_qty: eachSpreadOrder?.nRegularLot,
                    count: 1,
                    exchange: spreadOrderData[WATCHLIST_GRID_INDEX?.EXCHANGE_SEGMENT],
                    expiryDate: moment(convertToDate(eachSpreadOrder?.nExpiryDate)).format("YYYY-MM-DD"),
                    // Ajitesh 01/10/2024 adds correct scripinfo property below as received from api/promise so correct symbol is used to call API for market depth on multileg screen
                    extraInfo: scripinfoForEachLeg[i],
                    instrument: orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT],
                    legNumber: i + 1,
                    legPrice: objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltp ? objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltp : spreadOrderInfo[0]?.amount || "0.00",
                    ltp: objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltp ? objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltp : spreadOrderInfo[0]?.amount || "0.00",
                    ltpPercent: objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltpPercent ? objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.ltpPercent : spreadOrderInfo[0]?.amount || "0.00",
                    changeInLtp: objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.changeInLtp ? objTwoltps[`${orderInfo[WATCHLIST_GRID_INDEX?.SEGMENT_ID] + '_' + eachSpreadOrder?.nToken}`]?.changeInLtp : spreadOrderInfo[0]?.amount || "0.00",
                    optiontype: "", // Ajitesh: Keeping this blank as when converting spread -> multileg XX is shown on order confirmation screen which is wrong
                    orderType: spreadOrderInfo?.orderType,
                    // Ajitesh 12-09-2024 Changes below property to get correct price tick from watchlist
                    priceTick: orderInfo?.[WATCHLIST_GRID_INDEX.PRICE_TICK],
                    strikeprice: 'NA',
                    symbol: eachSpreadOrder?.sSymbol,
                    token: eachSpreadOrder?.nToken,
                    expiryList: arrFutureTabData,
                    // Ajitesh 12-09-2024 Adds below 2 properties when spread order is converted to multileg to fix issue of incorrect pricetick msg
                    decLoc: orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                    decimalLocatorLength: orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                };
            });
            dispatch(getMultiLegData([...correctScripInfoForEachLeg]));
            setActiveTabKey(ORDER_TYPES.MULTI_LEG);
        });

    }, [setActiveTabKey, spreadOrderArr, dispatch, buyAndSellScrip, spreadOrderData, objTwoltps, orderInfo, spreadOrderInfo, arrFutureTabData]);
    //Parshva S : 20-03-2024 : BT-107070 - Breeze - Spread Order entry - End

    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - Start
    const handleSelectScripFromGlobalSearch = useCallback((scrip, reset = true) => {
        if (reset) {
            setSpreadOrderInfo({ intradayLimit: 0, quantity: 1, amount: '0.00', validity: ORDER_VALIDITY.DAY, exchange: "", orderType: ORDER_ENTRY_TYPES.RL_MKT });
            setSellBuyBtnSwapClick(true);
            setBuyAndSellScrip([
                { ...spreadOrderArr[0], buySellType: 'SELL' },
                { ...spreadOrderArr[1], buySellType: 'BUY' },
            ]);
            dispatch(getSpreadOrderSuccess({}));
        }
        if (scrip && scrip[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) { //BT-106965 : OrderCart : ManasaB : 26-09-2024 : Smoke testing issue : Blank page on click of Spread from Order cart
            setIsToggleInput(false);
            setSpreadOrderData([...scrip]);
            var spreadPaylod =
            {
                "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
                "symbol": scrip[WATCHLIST_GRID_INDEX.SYMBOL],
                "token": scrip[WATCHLIST_GRID_INDEX.TOKEN]
            };
            dispatch(getSpreadOrder(spreadPaylod));
            dispatch(getScripOrderInfo({ activeExchangeId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID], scripData: scrip }));
            dispatch(handleModalData({ data: { spreadArr: scrip, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 4000, message: "Selected scrip is not eligible for Spread Orders. Please select a valid scrip." }));
        }
    }, [dispatch, spreadOrderArr]);

    const [isToggleInput, setIsToggleInput] = useState(false);
    //Ameersha N : 22-08-2023 : BT-107070 - Breeze - Spread Order entry - End

    useEffect(() => {
        if (!spreadOrderArr[0]?.nQuantity && layoutType !== LAYOUT_TYPE.VERTICAL) {
            handleSelectScripFromGlobalSearch(orderInfo, false);
        }
    }, []);

    useEffect(() => {
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            setIsLoader(true);
            setIsToggleInput(false);
            setSpreadOrderData([...orderInfo]);
            var spreadPaylod =
            {
                "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
                "symbol": orderInfo[WATCHLIST_GRID_INDEX.SYMBOL],
                "token": orderInfo[WATCHLIST_GRID_INDEX.TOKEN]
            };
            dispatch(getSpreadOrder(spreadPaylod));
            setSpreadOrderInfo({ intradayLimit: 0, quantity: 1, amount: '0.00', validity: ORDER_VALIDITY.DAY, exchange: "", orderType: ORDER_ENTRY_TYPES.RL_MKT });
            setSellBuyBtnSwapClick(true);
            setBuyAndSellScrip([
                { ...spreadOrderArr[0], buySellType: 'SELL' },
                { ...spreadOrderArr[1], buySellType: 'BUY' },
            ]);
            setTimeout(() => {
                setIsLoader(false);
            }, 500);
        }
    }, [orderInfo]);

    const marginInfoHandler = useCallback((strProductType, nQuantity) => {
        let nPrice = parseFloat(spreadOrderInfo?.amount);
        if (toggleBracketOrder?.isShow) {
            if (!isNaN(parseFloat(spreadOrderInfo?.intradayLimit)) && parseFloat(spreadOrderInfo?.intradayLimit) > 0) {
                nPrice = parseFloat(spreadOrderInfo?.intradayLimit);
            } else {
                nPrice = 0;
            }
        } else {
            nPrice = parseFloat(spreadOrderInfo.amount);
        }
        if (strProductType && typeof strProductType == 'string') {
            strProductType = getProductTypeValue(strProductType?.toUpperCase()) || '';
        } else {
            strProductType = getProductTypeValue(selectOrderOption?.productType?.toUpperCase()) || '';
        }
        if (!isNaN(parseInt(spreadOrderInfo?.quantity)) && parseInt(nQuantity) > 0) {
            nQuantity = parseInt(nQuantity);
        } else {
            nQuantity = parseInt(spreadOrderInfo?.quantity);
        }

        let arrPayload = spreadOrderArr?.map((item, index) => {
            return {
                "LegNo": index + 1,
                "BuyOrSell": index + 1,
                "MarketSegmentId": 1,//no data present for spread
                "Token": item?.nToken,
                "Quantity": item?.nRegularLot,
                "Price": Math.round(item?.nStrikePrice * orderInfo?.[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]),
                "MktFlag": 1, //this is dummy data
                "OldPrice": 0,
                "OldQuantity": 0,
                "ProductType": "D",
                "LegIndicator": 0
            };
        });
        dispatch(getOrderMarginInfo(arrPayload));
    }, [dispatch, spreadOrderInfo, selectOrderOption, spreadOrderArr, toggleBracketOrder, orderInfo]);

    //Ameersha N : 30-01-2024 : BT-107070 - Breeze - Spread Order entry - Start
    const handlePriceBlur = useCallback(() => {
        setSpreadOrderInfo(prevState => {
            return { ...prevState, amount: prevState?.amount ? parseFloat(prevState?.amount)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) : 0.00.toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) };
        });
    }, [orderInfo]);
    //Ameersha N : 30-01-2024 : BT-107070 - Breeze - Spread Order entry - Start
    const handleOrder = (e) => {
        setSpreadOrderInfo({ ...spreadOrderInfo, orderType: e });
        if (buySellBtnSwapClick) {
            setSpreadOrderInfo(prevState => { return { ...prevState, orderType: e, amount: isNaN(parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.askPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])) ? 0.00.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) : parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.askPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) }; });
        } else {
            setSpreadOrderInfo(prevState => { return { ...prevState, orderType: e, amount: isNaN(parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.bidPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])) ? 0.00.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) : parseFloat(objSpreadBidAndAskPrice[`${orderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]}`]?.bidPrice)?.toFixed(orderInfo[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH]) }; });
        }
    };

    useEffect(() => {
        if (orderInfo?.length > 0 && !arrMarginInfo && parseFloat(spreadOrderInfo?.amount) > 0) {
            if (orderInfo[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) {
                marginInfoHandler();
            } else {
                if (selectOrderOption?.productType === ORDER_PRODUCT_TYPES.CARRYFORWARD && spreadOrderInfo?.quantity ===
                    orderInfo[WATCHLIST_GRID_INDEX.REGULAR_LOT]) {
                    marginInfoHandler();
                }
            }
        } else { }
    }, [orderInfo, arrMarginInfo, spreadOrderInfo, marginInfoHandler, selectOrderOption?.productType]);

    useEffect(() => {
        setTimeout(() => {
            if (spreadOrderArr[0]?.nQuantity) {
                setSpreadOrderInfo({
                    ...spreadOrderInfo,
                    orderType: modalData?.data?.isRL ? ORDER_ENTRY_TYPES.RL : ORDER_ENTRY_TYPES.RL_MKT,
                    quantity: parseInt(spreadOrderArr[0]?.nQuantity),
                    amount: parseFloat(spreadOrderArr[0]?.nPrice).toFixed(orderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]),
                });
            }
        }, 300);
    }, []);

    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders Start

    useEffect(() => {
        if (orderInfo && orderInfo[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {//ManasaB : 11-10-2024 : Blank page issue from Order cart to spread
            if (!spreadOrderInfo.quantity || spreadOrderInfo.quantity === 0 || spreadOrderInfo.quantity === '0' || (orderInfo[WATCHLIST_GRID_INDEX?.NSPREAD] === 1 && spreadOrderArr?.length === 0)) {
                setDisablePlaceOrder(true);
            } else {
                setDisablePlaceOrder(false);
            }
        } else {
            setDisablePlaceOrder(true);
        }
    }, [orderInfo, spreadOrderArr, spreadOrderInfo]);

    useEffect(() => {
        setIsLoader(true);
        setTimeout(() => {
            setIsLoader(false);
        }, 500);
    }, []);

    useEffect(() => {
        const clickFunction = (event) => {
            if (isToggleInput) {
                if (!inlineSearchRef?.current?.contains(event.target) && !event.target.matches('.inline-search-wrap ,.inline-search-scrip-list, .inline-search-scrip-list *')) {
                    setIsToggleInput(false);
                } else { }
            } else { }
        };
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, [isToggleInput]);
    // Parshva S : 14/03/2024 : BT107070 Breeze Spread Orders End
    useEffect(() => {
        if (layoutType === LAYOUT_TYPE.VERTICAL) {
            if (spreadSideOrderStatus) {
                setSpreadOrderInfo({ intradayLimit: 0, quantity: multiSpreadOrderInfo?.quantity, amount: multiSpreadOrderInfo?.price, validity: ORDER_VALIDITY.DAY, exchange: "", orderType: Object.keys(multiSpreadOrderInfo).length > 0 ? multiSpreadOrderInfo?.orderType : ORDER_ENTRY_TYPES.RL_MKT });
                setSpreadOrderData(orderInfo);
                dispatch(handleSpreadSideOrder(false));
            }
        }
    }, [multiSpreadOrderInfo, spreadSideOrderStatus, orderInfo, dispatch, layoutType]);




    return (
        layoutType === LAYOUT_TYPE.HORIZONTAL ?
            <Container data-testid='spread-order-container' fluid className='p-0'>
                <form onSubmit={handlePlaceOrderButton}>
                    {/*  Vaibhav Singh : BT-106776 - 24-11-2023-  Added Modal - Start  */}
                    {/* <BrokerageModalMultiLeg sentFrom='spread' spreadOrderInfo={spreadOrderInfo} /> */}
                    <LoginLoader spinner={isLoader} spinnerContent={"Loading"} />
                    {/*  Vaibhav Singh : BT-106776 - 24-11-2023-  Added Modal - End  */}
                    {orderInfo?.length && (orderInfo?.[WATCHLIST_GRID_INDEX.SERIES] !== "EQ" || orderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 1) ?
                        spreadOrderArr?.length ?
                            <div>
                                <Row className='g-0'>
                                    <Col>
                                        <div data-testid='spread-order-table-element' className='table-responsive flex-nowrap my-3'>
                                            <table className='table table-sm table-hover table-striped table-bordered'>
                                                <thead>
                                                    <tr>
                                                        {objDropdownOptions?.heading?.map((heading, i) =>
                                                            <th key={i} className='align-middle text-center'>
                                                                <div data-testid={`spread-order-table-header-${i}`} className='font-size1 color-subtext'>{heading}</div>
                                                            </th>
                                                        )}

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className='p-0'>
                                                            <div className='spread-toggle-wrap'>
                                                                {buySellBtnSwapClick ?
                                                                    <>
                                                                        <div data-testid='spread-order-sell-button' className='font-medium font-size2 color-active-text background-negative h_45 d-flex justify-content-center align-items-start pt-1'>SELL</div>
                                                                        <div data-testid='spread-order-buy-button' className='font-medium font-size2 color-active-text background-positive h_45 d-flex justify-content-center align-items-end pb-1'>BUY</div>
                                                                        <div data-testid='spread-order-toggle-sell-buy-container' className='spread-toggle-container' id="buySellToggele" tabIndex='0' onKeyPress={handleKeyDownOnDiv} onClick={onSwapClick}>
                                                                            <div className={`icon-16 icon-dark icon-swap-vertical ${spreadConfirmationModalData?.gatewayOrderNo ? 'icon-disabled' : ""}`} id="buySellToggeleIcon"></div>
                                                                        </div>
                                                                    </>
                                                                    : <>
                                                                        <div data-testid='spread-order-buy-button' className='font-medium font-size2 color-active-text background-positive h_45 d-flex justify-content-center align-items-start pt-1'>BUY</div>
                                                                        <div data-testid='spread-order-sell-button' className='font-medium font-size2 color-active-text background-negative h_45 d-flex justify-content-center align-items-end pb-1'>SELL</div>
                                                                        <div data-testid='spread-order-toggle-buy-sell-container' className='spread-toggle-container' id="buySellToggele" tabIndex='0' onKeyPress={handleKeyDownOnDiv} onClick={onSwapClick}>
                                                                            <div className={`icon-16 icon-dark icon-swap-vertical ${spreadConfirmationModalData?.gatewayOrderNo ? 'icon-disabled' : ""}`} id="buySellToggeleIcon"></div>
                                                                        </div>
                                                                    </>
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className='align-start text-nowrap pt-2'>
                                                            <div className='d-flex flex-column justify-content-center'>
                                                                <div data-testid="spread-order-expiry-start-date" className='font-medium font-size1 color-text bdr-btm pb-2 mb-2'>{expiryDateStart}</div>
                                                                <div data-testid="spread-order-expiry-end-date" className='font-medium font-size1 color-text'>{expiryDateEnd}</div>
                                                            </div>
                                                        </td>
                                                        <td className='align-start text-nowrap pt-2'>
                                                            <div className='d-flex justify-content-between align-items-start'>
                                                                <div className='me-2'>
                                                                    {isToggleInput ?
                                                                        <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} bOpt={false} />
                                                                        :
                                                                        <>
                                                                            <div data-testid='spread-order-symbol' className='font-medium font-size2 color-text'>{spreadOrderData?.length ? spreadOrderData[WATCHLIST_GRID_INDEX?.SYMBOL] : ""}</div>
                                                                            <div data-testid='spread-order-expiry' className='font-medium font-size1 color-text'>{expiryDateStart} - {expiryDateEnd} FUT</div>
                                                                        </>
                                                                    }
                                                                </div>
                                                                {!spreadConfirmationModalData?.gatewayOrderNo &&
                                                                    <div>
                                                                        <BzButton data-testid='spread-order-search-button' className='icon-btn p-0 px-1' type="button" onClick={() => setIsToggleInput(!isToggleInput)}>
                                                                            <span className='icon-14 icon-search icon-dark'></span>
                                                                        </BzButton>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className='align-start text-center text-nowrap pt-2'>
                                                            <div className='Bzmodalselect-dropdown'>
                                                                <BzDropdown data-testid='spread-order-type-dropdown'>
                                                                    <Dropdown.Toggle data-testid='spread-order-type-dropdown-toggle' className='btn-default'>{spreadOrderInfo?.orderType}</Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item data-testid='spread-order-type-dropdown-rlmkt-item' onClick={() => handleOrder(ORDER_ENTRY_TYPES.RL_MKT)}>{ORDER_ENTRY_TYPES.RL_MKT}</Dropdown.Item>
                                                                        <Dropdown.Item data-testid='spread-order-type-dropdown-rl-item' onClick={() => handleOrder(ORDER_ENTRY_TYPES.RL)}>{ORDER_ENTRY_TYPES.RL}</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </BzDropdown>
                                                            </div>
                                                        </td>
                                                        <td className='align-start text-nowrap pt-2'>
                                                            <div className='input-group position-relative'>
                                                                <div data-testid='spread-order-quantity-decrease-icon' className='icon-12 icon-order-decrease input-number-left-wrap' id="quantitySub" onClick={onHandleClick.bind(this, "quantitySub")
                                                                }></div>
                                                                <BzInputText data-testid='spread-order-quantity-input' size='sm' type='text' name="quantity" autoFocus placeholder="0" className='font-regular text-center w_100' value={spreadOrderInfo?.quantity} onKeyDown={e => {
                                                                    if (e.key === " " || e.key === '-' || e.key === '+' || e.key === '.') {
                                                                        e.preventDefault();
                                                                    } else { }
                                                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                                        e.preventDefault();
                                                                        if (e.key === 'ArrowUp') {
                                                                            onHandleClick("quantityAdd");
                                                                        } else if (e.key === 'ArrowDown') {
                                                                            onHandleClick("quantitySub");
                                                                        }
                                                                    }
                                                                }} onChange={handleChange} onBlur={() => setSpreadOrderInfo(prevState => ({ ...prevState, quantity: prevState?.quantity || '0' }))} />
                                                                <div data-testid='spread-order-quantity-increase-icon' className='icon-12 icon-order-increase input-number-right-wrap' id="quantityAdd" onClick={
                                                                    onHandleClick.bind(this, "quantityAdd")
                                                                }></div>
                                                            </div>
                                                            <div data-testid='spread-order-quantity-label' className='font-regular font-size1 color-subtext text-center mt-1'>(1 Lot = {spreadOrderArr?.length ? spreadOrderArr[0]?.nRegularLot : ""} {orderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT]})</div>
                                                        </td>
                                                        <td className='align-start text-nowrap pt-2'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='input-group position-relative'>
                                                                    <div data-testid='spread-order-amount-decrease-icon' className='icon-12 icon-order-decrease input-number-left-wrap' id="amountSub" onClick={() => {
                                                                        if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {
                                                                            onHandleClick("amountSub");
                                                                        }
                                                                    }}></div>
                                                                    <BzInputText data-testid='spread-order-amount-input' size='sm' type='text' name="amount" placeholder="0.00" disabled={spreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL_MKT} className={`font-regular text-center w_100 ${spreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL_MKT ? 'disabled' : ''} `} defaultValue={0.00} value={spreadOrderInfo?.amount} /* Parshva S: BT: 107070 : 2/3/24 */
                                                                        onKeyDown={e => {
                                                                            if (e.key === " ") { e.preventDefault(); }
                                                                            if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                                                                                e.preventDefault();
                                                                                if (e.key === 'ArrowUp') {
                                                                                    onHandleClick("amountAdd");
                                                                                } else if (e.key === 'ArrowDown') {
                                                                                    onHandleClick("amountSub");
                                                                                }
                                                                            }
                                                                        }} onChange={(e) => { if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) { handleChange(e); } }} onBlur={(e) => handlePriceBlur(e)} />
                                                                    <div data-testid='spread-order-amount-increase-icon' className='icon-12 icon-order-increase input-number-right-wrap' id="amountAdd" onClick={() => {
                                                                        if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {
                                                                            onHandleClick("amountAdd");
                                                                        }
                                                                    }
                                                                    }></div>
                                                                </div>
                                                                <div data-testid='spread-order-market-depth-icon' className='icon-20 icon-marketdepth ms-2 me-1' onClick={handleMarketDepthClick}></div>
                                                            </div>
                                                        </td>
                                                        <td className='align-start text-center text-nowrap pt-2'>
                                                            <div data-testid='spread-order-validity' className='font-regular font-size1 color-subtext'>DAY</div>
                                                        </td>
                                                    </tr >
                                                </tbody >
                                            </table >
                                        </div >
                                    </Col >
                                </Row >
                                <Row className='g-0 mb-4'>
                                    {spreadConfirmationModalData?.gatewayOrderNo || orderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE] === 'NCDEX' ? null : IS_MULTILEG_ALLOWED &&
                                        <Col md='auto'>
                                            <div data-testid='spread-order-convert-to-multi-leg-order' className='d-flex align-items-center focus' id="convertToMultiLegOrder" tabIndex='0' onKeyPress={handleKeyDownOnDiv} onClick={handleConvertSpreadToMultiLeg}>
                                                <div className='icon-16 icon-expand-fullview background-textual-link-withicon cursor-pointer'></div>
                                                <div data-testid='spread-order-convert-to-multi-leg-order-label' className='font-medium font-size3 color-textual-link-withicon cursor-pointer ms-2'>Convert to Multi Leg Order</div>
                                            </div>
                                        </Col>}
                                    <Col className='d-flex justify-content-end align-items-start'>
                                        <div data-testid='spread-order-margin-benefits-label' className='font-regular font-size2 color-subtext'>Spread Order has margin benefits</div>
                                        <BzToolTip data-testid='spread-order-margin-benefits-tooltip' placement='left' TooltipMsg='Spread order helps you take position in two calender contract simultaneously and also requires lesser margin than two individual orders in these contracts.'>
                                            <div data-testid='spread-order-margin-benefits-icon' className='icon-16 icon-info icon-dark ms-2'></div>
                                        </BzToolTip>
                                    </Col>
                                </Row>
                            </div > :
                            // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--Start
                            (orderInfo && orderInfo[WATCHLIST_GRID_INDEX?.NSPREAD] === 1 && spreadOrderArr?.length === 0) ?  //BT-106965 : OrderCart : ManasaB : 26-09-2024 : Smoke testing issue : Blank page on click of Spread from Order cart
                                <Row className='g-0'>
                                    <Col md={6} className='mrgauto'>
                                        <div data-testid="spread-order-zero-state" className='zero-state-alerts zero-state-alerts-lg'>
                                            <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                            <div className='font-regular font-size2 color-nodata text-center'>Uh oh! Looks like we missed something.</div>
                                            <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon. Meanwhile try</div>
                                            <div className='font-regular font-size2 color-nodata text-center'><span className='color-primary'>Refreshing the page</span> or come back later.</div>
                                            <div className='font-regular font-size2 color-nodata text-center'>If the problem still persists, please Contact Support.</div>
                                        </div>
                                    </Col>
                                </Row>
                                // Ameersha N : Breeze : 23-02-2024 : BT-102298 : Issue NSE FNO FIX--End
                                : <Row className='g-0 mt-3 mb-4'>
                                    <Col md={8} className='m-auto oe-note-card'>
                                        <div className='d-flex align-items-center'>
                                            <div className='icon-16 icon-info icon-dark'></div>
                                            <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                        </div>

                                        <div className='font-regular font-size3 color-text py-2'>Spread Orders can only be placed for <span className='font-medium'>Futures / Options / Commodity / Currency </span>segments. For Equity stocks please place a Single Scrip / Order Cart!</div>
                                    </Col>
                                </Row> :
                        <Row className='g-0 mt-3 mb-4'>
                            <Col md={8} className='m-auto oe-note-card'>
                                <div className='d-flex align-items-center'>
                                    <div className='icon-16 icon-info icon-dark'></div>
                                    <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                </div>

                                <div className='font-regular font-size3 color-text py-2'>Spread Orders can only be placed for <span className='font-medium'>Futures / Options / Commodity / Currency </span>segments. For Equity stocks please place a Single Scrip / Order Cart!</div>
                            </Col>
                        </Row>
                    }

                    <Row className='g-0 bdr-top py-2'>
                        <Col md={7} className='d-flex justify-content-start align-items-center'>
                            <>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div data-testid="spread-order-approx-margin-label" className='font-regular font-size1 color-text'>Approx. Margin</div>
                                    {
                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            <div data-testid="spread-order-approx-margin-value" className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.ApproxMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.ApproxMargin), true) : arrMarginInfo?.ApproxMargin ?? 0}</div>
                                    }
                                </div>
                                <div className='d-flex flex-column justify-content-start pe-4'>
                                    <div data-testid="spread-order-available-margin-label" className='font-regular font-size1 color-text'>Available Margin: </div>
                                    {

                                        isLoadingMarginInfo ?
                                            <BzDotsLoader />
                                            :
                                            <div data-testid="spread-order-available-margin-value" className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin ?? 0}</div>
                                    }
                                </div>
                                {
                                    !isLoadingMarginInfo &&
                                    <div data-testid="spread-update-margin-icon" className='d-flex align-items-center pe-4 cursor-pointer focus' tabIndex='0' id='updateMarginInfoMutliLeg' onClick={() => { marginInfoHandler(); }}>
                                        <div className='icon-12 icon-refresh background-textual-link-withicon'></div>
                                        <div className='font-medium font-size1 color-textual-link-withicon ms-2'>Update</div>
                                    </div>
                                }
                            </>

                        </Col>
                        {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - Start  */}
                        <Col md={5} className='d-flex justify-content-end align-items-center'>
                            <div data-testid='spread-order-brokerage-charge-button' className='font-medium font-size1 color-text me-4 focus p-1 cursor-pointer' tabIndex='0' id='viewBrokerageChargeMultileg' onClick={() => { handleBrokerageForSpread(); }}>Brokerage &amp; Charges</div>
                            <BzButton data-testid={`spread-order-${spreadConfirmationModalData?.gatewayOrderNo ? "modify-order-button" : "place-order-button"}`} type={'submit'} disabled={disablePlaceOrder} className={`btn btn-md ${activeButtonToggleIndex ? 'btn-negative' : 'btn-positive'} text-capitalize`} onClick={handlePlaceOrderButton}>{`${spreadConfirmationModalData?.gatewayOrderNo ? "Modify" : "Place"}`} Order</BzButton>
                        </Col>
                        {/* Vaibhav Singh : BT-106776 - 08-11-2023-  Added Modal - Start  */}
                    </Row>
                    {
                        isShowMarketDepth &&
                        <div ref={marketDepthRef}>
                            <Row className='g-0 bdr-top px-2 py-3'>
                                <Row className='g-0'>
                                    <Col md={12} className='d-flex justify-content-start align-items-center'>
                                        <Button data-testid='spread-market-depth-button' className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                        <Button data-testid='spread-support-resistance-button' className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                    </Col>
                                </Row>
                                {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth onValueClick={onValueClick} heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={layoutType} /> : null}
                            </Row>
                        </div>
                    }
                </form >
            </Container >
            : (
                layoutType === LAYOUT_TYPE.VERTICAL ?
                    <div className='sticky-orderticket-spread'>
                        <Container fluid className='p-0 pb-3 px-3'>
                            <LoginLoader spinner={isLoader} spinnerContent={"Loading"} />
                            {orderInfo?.length && (orderInfo?.[WATCHLIST_GRID_INDEX.SERIES] !== "EQ" || orderInfo?.[WATCHLIST_GRID_INDEX.NSPREAD] === 1) ?
                                spreadOrderArr?.length ?
                                    <Container fluid className='p-0'>
                                        <Row className='g-0 mb-2'>
                                            <Col md={8} className='text-start'>
                                                {isToggleInput ?
                                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} bOpt={false} />
                                                    : <>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='font-medium font-size4 color-text text-uppercase me-2'>{spreadOrderData?.length ? spreadOrderData[WATCHLIST_GRID_INDEX?.SYMBOL] : ""}</div>
                                                            <div className='icon-16 icon-search icon-dark' onClick={() => setIsToggleInput(true)}></div>
                                                        </div>
                                                        <div className='font-regular font-size3 color-subtext'>{orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]}</div>
                                                    </>}
                                            </Col>
                                            <Col md={4} className='text-end'>
                                                <div className='font-medium font-size4 color-text'>{arrScripInformation[WATCHLIST_GRID_INDEX?.LAST_TRADE_PRICE] || 0.00.toFixed(arrScripInformation[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])}</div>
                                                <div className={`font-regular font-size3 color-text ${arrScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] > 0 ? 'color-positive' : arrScripInformation[WATCHLIST_GRID_INDEX.CHANGE_IN_LTP] < 0 ? 'color-negative' : ''}`}>{arrScripInformation[WATCHLIST_GRID_INDEX?.NET_CHANGE_FROM_PRE_CLOSE] || 0.00.toFixed(arrScripInformation[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])} ({arrScripInformation[WATCHLIST_GRID_INDEX?.CHANGE_IN_LTP] || 0.00.toFixed(arrScripInformation[WATCHLIST_GRID_INDEX?.DECIMAL_LOCATOR_LENGTH])}%)</div>
                                            </Col>
                                        </Row>
                                        {/* <Row className='g-0 mb-2'>
                                            <Col md={12}>
                                                {isToggleInput ?
                                                    <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setBToggleSearchBar} bOpt={false} />
                                                    :
                                                    <>
                                                        <div className='font-medium font-size2 color-text'>{spreadOrderData?.length ? spreadOrderData[WATCHLIST_GRID_INDEX?.SYMBOL] : ""}</div>
                                                        <div className='font-medium font-size1 color-text'>{expiryDateStart} - {expiryDateEnd} FUT</div>
                                                    </>}
                                            </Col>
                                        </Row> */}
                                        <Row className='g-0 mb-2'>
                                            <Col>
                                                <div className='font-medium font-size3 color-text'>{spreadOrderData?.length ? spreadOrderData[WATCHLIST_GRID_INDEX?.SYMBOL] : ""} : {expiryDateStart} - {expiryDateEnd} FUT</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <div className='d-flex justify-content-center spread-toggle-wrap'>
                                                <Col className={`${buySellBtnSwapClick ? 'background-negative' : 'background-positive'} text-center rounded-start p-3`}>
                                                    <div className='font-medium font-size2 color-active-text text-uppercase'>{buySellBtnSwapClick ? 'SELL' : 'BUY'}</div>
                                                    <div className='font-medium font-size2 color-active-text'>{expiryDateStart}</div>
                                                    {/* <span className='font-regular'>'23</span> */}
                                                </Col>
                                                <Col className={`${buySellBtnSwapClick ? 'background-positive' : 'background-negative'} text-center rounded-end p-3`}>
                                                    <div className='font-medium font-size2 color-active-text text-uppercase'>{buySellBtnSwapClick ? 'BUY' : 'SELL'}</div>
                                                    <div className='font-medium font-size2 color-active-text'>{expiryDateEnd}
                                                        {/* <span className='font-regular'>'23</span> */}</div>
                                                </Col>
                                                <div className='spread-toggle-container'>
                                                    <div className='icon-16 icon-dark icon-swap-vertical rotate-90' onClick={onSwapClick}></div>
                                                </div>
                                            </div>
                                        </Row>
                                        <Row className='mb-2'>
                                            <Col md={6} className='flex-column align-items-start'>
                                                <div className='font-regular font-size3 color-subtext mb-1'>Order Type</div>
                                                <div className='Bzmodalselect-dropdown'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle size='sm' name="orderType" className='btn-default'>{spreadOrderInfo?.orderType}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item className='font-regular font-size2 color-text text-uppercase' onClick={() => handleOrder(ORDER_ENTRY_TYPES.RL_MKT)}>{ORDER_ENTRY_TYPES.RL_MKT}</Dropdown.Item>
                                                            <Dropdown.Item className='font-regular font-size2 color-text text-uppercase' onClick={() => handleOrder(ORDER_ENTRY_TYPES.RL)}>{ORDER_ENTRY_TYPES.RL}</Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </Col>
                                            <Col md={6} className='flex-column align-items-start'>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Lots</div>
                                                <div className='input-group position-relative'>
                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' id='quantitySub' onClick={onHandleClick.bind(this, "quantitySub")}></div>
                                                    <BzInputText size='sm' type='text' autoFocus name="quantity" placeholder="0" className='font-regular text-center' value={spreadOrderInfo?.quantity} onKeyDown={e => {
                                                        if (e.key === " " || e.key === '-' || e.key === '+' || e.key === '.') {
                                                            e.preventDefault();
                                                        } else { }
                                                        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                            if (e.key === 'ArrowUp') {
                                                                onHandleClick("quantityAdd");
                                                            } else if (e.key === 'ArrowDown') {
                                                                onHandleClick("quantitySub");
                                                            }
                                                        }
                                                    }} onChange={handleChange} onBlur={() => setSpreadOrderInfo(prevState => ({ ...prevState, quantity: prevState?.quantity || '0' }))} />
                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' id="quantityAdd" onClick={
                                                        onHandleClick.bind(this, "quantityAdd")
                                                    }></div>
                                                </div>
                                                <div className='font-medium font-size1 color-subtext'>1 Lot = {spreadOrderArr?.length ? spreadOrderArr[0]?.nRegularLot : ""} {orderInfo?.[WATCHLIST_GRID_INDEX.PRICE_QUOTATION_UNIT]}</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col md={6} className='flex-column align-items-start'>
                                                <div className='d-flex align-items-center justify-content-between mb-1'>
                                                    <div className='font-regular font-size2 color-subtext mb-1'>Price</div>
                                                    <div className='icon-20 icon-marketdepth ms-3' onClick={handleMarketDepthClick}></div>
                                                </div>
                                                <div className='input-group position-relative'>
                                                    <div className='icon-12 icon-order-decrease input-number-left-wrap' id="amountSub" onClick={() => {
                                                        if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {
                                                            onHandleClick("amountSub");
                                                        }
                                                    }}></div>
                                                    <BzInputText size='sm' type='text' name="amount" placeholder="0.00" disabled={spreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL_MKT} className={`font-regular text-center ${spreadOrderInfo?.orderType === ORDER_ENTRY_TYPES.RL_MKT ? 'disabled' : ''} `} defaultValue={0.00} value={spreadOrderInfo?.amount} /* Parshva S: BT: 107070 : 2/3/24 */
                                                        onKeyDown={e => {
                                                            if (e.key === " ") { e.preventDefault(); }
                                                            if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
                                                                e.preventDefault();
                                                                if (e.key === 'ArrowUp') {
                                                                    onHandleClick("amountAdd");
                                                                } else if (e.key === 'ArrowDown') {
                                                                    onHandleClick("amountSub");
                                                                }
                                                            }
                                                        }} onChange={(e) => { if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) { handleChange(e); } }} onBlur={(e) => handlePriceBlur(e)} />
                                                    <div className='icon-12 icon-order-increase input-number-right-wrap' id="amountAdd" onClick={() => {
                                                        if (spreadOrderInfo?.orderType !== ORDER_ENTRY_TYPES.RL_MKT) {
                                                            onHandleClick("amountAdd");
                                                        }
                                                    }
                                                    }></div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mb-2'>
                                            <Col>
                                                <div className='font-medium font-size1 color-subtext'>Validity: <span className='color-text'>DAY</span></div>
                                            </Col>
                                        </Row>
                                        {orderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE] === DISPLAY_EXCHANGE_NAME.NCDEX_EXCHANGE_TEXT ? null : <Row className='g-0 mb-2'>
                                            <Col md='auto'>
                                                <div className='d-flex align-items-center focus' onClick={handleConvertSpreadToMultiLeg}>
                                                    <div className='icon-16 icon-expand-fullview background-textual-link-withicon cursor-pointer'></div>
                                                    <div className='font-medium font-size3 color-textual-link-withicon cursor-pointer ms-2'>Convert to Multi Leg Order</div>
                                                </div>
                                            </Col>
                                        </Row>}
                                        <Row className='g-0 mb-2'>
                                            <Col className='d-flex'>
                                                <div className='font-regular font-size2 color-subtext'>Spread Order has margin benefits</div>
                                                <BzToolTip placement='top' TooltipMsg='Spread order helps you take position in two calender contract simultaneously and also requires lesser margin that two individual orders in these contracts.'>
                                                    <div className='icon-16 icon-info icon-dark ms-2'></div>
                                                </BzToolTip>
                                            </Col>
                                        </Row>
                                        {
                                            isShowMarketDepth &&
                                            <div ref={marketDepthRef}>
                                                <Row className='g-0 bdr-top px-2 py-2'>
                                                    <Row className='g-0'>
                                                        <Col md={12} className='d-flex justify-content-start align-items-center'>
                                                            <Button className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                                            <Button className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                                        </Col>
                                                    </Row>
                                                    {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth layoutType={layoutType} onValueClick={onValueClick} heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} layoutType={layoutType} /> : null}
                                                </Row>
                                            </div>
                                        }

                                    </Container>
                                    :
                                    (orderInfo && orderInfo[WATCHLIST_GRID_INDEX?.NSPREAD] === 1 && spreadOrderArr?.length === 0) ? <Row className='g-0'>
                                        <Col md={6} className='mrgauto'>
                                            <div className='zero-state-alerts zero-state-alerts-lg'>
                                                <ZeroStates subText="" isButtonShowing={false} icon='icon-64 icon-missed-something mb-3 mrgauto' />
                                                <div className='font-regular font-size2 color-nodata text-center'>Uh oh! Looks like we missed something.</div>
                                                <div className='font-regular font-size2 color-nodata text-center'>Let us fix the problem and get back to you soon. Meanwhile try</div>
                                                <div className='font-regular font-size2 color-nodata text-center'><span className='color-primary'>Refreshing the page</span> or come back later.</div>
                                                <div className='font-regular font-size2 color-nodata text-center'>If the problem still persists, please Contact Support.</div>
                                            </div>
                                        </Col>
                                    </Row>
                                        : <Row className='g-0 mt-3 mb-4'>
                                            <Col md={12} xl={8} className='m-auto oe-note-card'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='icon-16 icon-info icon-dark'></div>
                                                    <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                                </div>

                                                <div className='font-regular font-size3 color-text py-2'>Spread Orders can only be placed for <span className='font-medium'>Futures / Options / Commodity / Currency </span>segments. For Equity stocks please place a Single Scrip / Order Cart!</div>
                                            </Col>
                                        </Row> :
                                orderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT]?.includes('FUT') ?
                                    <Row className='g-0 mt-2'>
                                        <Col md={12} className='m-auto oe-note-card'>
                                            <div className='d-flex align-items-center'>
                                                <div className='icon-16 icon-info icon-dark'></div>
                                                <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                            </div>

                                            <div className='font-regular font-size3 color-text py-2'>Please choose a spread order to place your order</div>
                                        </Col>
                                    </Row> :
                                    <Row className='g-0 mt-2'>
                                        <Col md={12} className='m-auto oe-note-card'>
                                            <div className='d-flex align-items-center'>
                                                <div className='icon-16 icon-info icon-dark'></div>
                                                <div className='font-medium font-size3 color-text ms-2'>Please note</div>
                                            </div>
                                            <div className='font-regular font-size3 color-text py-2'>Spread Orders can only be placed for <span className='font-medium'>Futures / Options / Commodity / Currency </span>segments. For Equity stocks please place a Single Scrip / Order Cart!</div>
                                        </Col>
                                    </Row>
                            }
                        </Container>
                    </div> : null
            )
    );
};

export default memo(Spread);